export const REFERRALS_ENDPOINT_OP_MAINNET = 'https://subgraph.satsuma-prod.com/05943208e921/kwenta/referrals/api';
export const REFERRALS_ENDPOINTS = {
    10: REFERRALS_ENDPOINT_OP_MAINNET,
};
//# sourceMappingURL=referrals.js.map